var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookShareButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook-share-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.88,
    height: 38.48,
    viewBox: "0 0 122.88 38.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M118.69,0H4.19A4.21,4.21,0,0,0,0,4.19v30.1a4.2,4.2,0,0,0,4.19,4.19h114.5a4.2,4.2,0,0,0,4.19-4.19V4.19A4.21,4.21,0,0,0,118.69,0Z",
    fill: "#1877f2",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M52,21.34l3.13-.23a3,3,0,0,0,.42,1.34A1.65,1.65,0,0,0,57,23.2a1.45,1.45,0,0,0,1.09-.38,1.24,1.24,0,0,0,.38-.89,1.21,1.21,0,0,0-.36-.86,3.82,3.82,0,0,0-1.68-.72,6.73,6.73,0,0,1-3.09-1.5,3.22,3.22,0,0,1-.94-2.39,3.57,3.57,0,0,1,.48-1.8,3.38,3.38,0,0,1,1.43-1.34,6,6,0,0,1,2.63-.48,4.81,4.81,0,0,1,3.12.88,4,4,0,0,1,1.27,2.82l-3.1.21a2.07,2.07,0,0,0-.52-1.23,1.52,1.52,0,0,0-1.09-.38,1.24,1.24,0,0,0-.87.28.94.94,0,0,0-.29.69.72.72,0,0,0,.24.53,2.35,2.35,0,0,0,1.1.46,12.27,12.27,0,0,1,3.09,1.1,3.38,3.38,0,0,1,1.36,1.37,3.92,3.92,0,0,1,.43,1.83,4.37,4.37,0,0,1-.57,2.2,3.78,3.78,0,0,1-1.59,1.53,5.69,5.69,0,0,1-2.56.51c-1.82,0-3.08-.4-3.77-1.21A5.15,5.15,0,0,1,52,21.34Zm11.14-8.29h3.3v4.32H70V13.05h3.31V25.44H70v-5H66.4v5H63.1V13.05Zm19,10.34H78.37l-.54,2.05H74.46l4-12.39h3.61l4,12.39H82.64l-.54-2.05Zm-.69-2.68-1.17-4.45-1.17,4.45Zm5.77,4.73V13.05h5.5a7,7,0,0,1,2.33.3,2.6,2.6,0,0,1,1.31,1.13,3.84,3.84,0,0,1,.49,2,3.93,3.93,0,0,1-.38,1.78,3.25,3.25,0,0,1-1,1.22,3.61,3.61,0,0,1-1.16.49,2.9,2.9,0,0,1,.86.46,3.81,3.81,0,0,1,.52.65,5,5,0,0,1,.46.77l1.61,3.58H94l-1.76-3.78a3,3,0,0,0-.6-1,1.25,1.25,0,0,0-.81-.28h-.29v5Zm3.31-7.36h1.39a4.59,4.59,0,0,0,.88-.17.83.83,0,0,0,.53-.39,1.27,1.27,0,0,0,.21-.72,1.22,1.22,0,0,0-.33-.92,1.75,1.75,0,0,0-1.23-.32H90.49v2.52Zm8.24-5h8.83v2.64H102v2h5.12v2.52H102v2.44h5.68v2.81h-9V13.05Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M40.66,0V38.48H38.27V0Z",
    fill: "#166bda"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M31.43,18.75a12.18,12.18,0,1,0-14.07,12V22.26H14.25V18.75h3.11V16.07c0-3.05,1.81-4.74,4.59-4.74a17.55,17.55,0,0,1,2.71.25v3H23.13a1.78,1.78,0,0,0-2,1.91v2.28h3.39L24,22.25H21.13v8.51a12.14,12.14,0,0,0,10.3-12Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookShareButton);
export default __webpack_public_path__ + "static/media/facebook-share-button.db319975e20b7d9e8725ad49926bef31.svg";
export { ForwardRef as ReactComponent };